import React from 'react';
import useStyle from './iconButton.style';
import { FlatIcon } from '../../Icons/FlatIcon';
import { Icon } from '../../Icons';
import { MenuBurgerIcon } from 'components/atoms/Icons/MenuBurgerIcon';
import { classNames } from '../../../../helpers/style/classNames';

export interface IconButtonProps {
  onClick: () => void;
  variant?: 'backless' | 'flat' | 'elevate' | 'publicShopButton';
  color?: string;
  icon: Icon;
  size?: 'small' | 'normal' | 'large';
  notificationsCount?: number;
  isMenuBurger?: boolean;
}

export const IconButton = ({
  onClick,
  variant = 'elevate',
  color,
  icon,
  size = 'normal',
  notificationsCount = 0,
  isMenuBurger = false
}: IconButtonProps) => {
  const classes = useStyle({ color });

  return (
    <button
      onClick={onClick}
      className={classNames(
        [classes.root, classes[size]],
        [
          {
            condition: variant === 'elevate' || variant === 'publicShopButton',
            classe: classes.elevate
          },
          {
            condition: variant === 'backless',
            classe: classes.backless
          },
          {
            condition: variant === 'flat',
            classe: classes.flat
          },
          {
            condition: notificationsCount > 0,
            classe: classes.border
          },
          {
            condition: isMenuBurger || variant === 'publicShopButton',
            classe: classes.menuBurger
          }
        ]
      )}
    >
      {!isMenuBurger ? (
        <FlatIcon icon={icon} color={color && color} size={size} />
      ) : (
        <MenuBurgerIcon />
      )}
      {notificationsCount > 0 && (
        <div className={classes.notifs}>
          <span>{notificationsCount}</span>
        </div>
      )}
    </button>
  );
};
